export const flota = [
  {
    marca: "Fiat",
    imagen: "/images/home/whitecr3.png",
    modelo: "Cronos",
    puertas: 4,
    asientos: 5,
    combustible: "Nafta",
    motor: "1.3L",
    direccion: "Asistida",
    linea1: "A/C - Bluetooth",
    linea2: "Radio AM-FM-USB",
    linea3: "Espejos eléctricos - Amplio Baúl",
    transmision: "Manual",
    codigo: "FCM",
  },

  {
    marca: "Toyota",
    imagen: "/images/home/corolla.png",
    modelo: "Corolla",
    puertas: 4,
    asientos: 5,
    combustible: "Nafta",
    motor: "2.0L",
    direccion: "Asistida",
    linea1: "A/C - Bluetooth",
    linea2: "Radio AM-FM-USB",
    linea3: "Espejos eléctricos - Navegador",
    transmision: "Automático",
    codigo: "TCA",
  },

  {
    marca: "Chevrolet",
    imagen: "/images/home/spin.png",
    modelo: "Spin",
    puertas: 5,
    asientos: 7,
    combustible: "Nafta",
    motor: "1.8L",
    direccion: "Asistida",
    linea1: "A/C - Bluetooth",
    linea2: "Radio AM-FM-USB",
    linea3: "Portaequipajes - Amplio Baúl",
    transmision: "Manual",
    codigo: "CSM",
  },

  {
    marca: "Toyota",
    imagen: "/images/home/etios.png",
    modelo: "Etios",
    puertas: 4,
    asientos: 5,
    combustible: "Nafta",
    motor: "1.3L",
    direccion: "Asistida",
    linea1: "A/C - Bluetooth",
    linea2: "Radio AM-FM-USB",
    linea3: "Espejos eléctricos - Amplio baúl",
    transmision: "Manual",
    codigo: "TEM",
  },
  {
    marca: "Fiat",
    imagen: "/images/home/whitecr3.png",
    modelo: "Cronos",
    puertas: 4,
    asientos: 5,
    motor: "1.3L - Nafta",
    direccion: "Asistida",
    linea1: "A/C - Bluetooth",
    linea2: "Radio AM-FM-USB",
    linea3: "Espejos eléctricos - Amplio Baúl",
    transmision: "Automático",
    codigo: "FCA",
  },
];

export const automaticos = flota.filter(
  (auto) => auto.transmision === "Automático"
);

export const manuales = flota.filter((auto) => auto.transmision === "Manual");

export const frecuentes = [
  {
    title: "¿A qué teléfono debo comunicarme para el alquiler de vehículos? ",
    content: `Podes comunicarte con nosotros por Whatsapp al +54 9 11 5850-323 o al +54 9 11 3071-0101`,
  },
  {
    title: "¿Cuales son los requisitos que necesito para alquilar el vehículo?",
    content: `<ul>
    <li>- Debe ser mayor de 22 años de edad.</li>
    <li>- Deberá contar con Lic. de conducir vigente, con antigüedad mínima a 2 años. </li>
    <li>- En caso de ser extranjeros, deberá presentar pasaporte válido. </li>
    <li>- Documento de identidad actualizado. </li>
    <li>- Deberá contar con una tarjeta de crédito a nombre del titular que efectúe la reserva con límite disponible para el bloqueo de depósito.</li>
    <li>- Extranjeros deberán contar con tarjeta de crédito internacional.</li>
    <li><span>IMPORTANTE</span>: Al momento de firmar el contrato de reserva, debe acercarse con copia impresa de todos los documentos solicitados. No serán aceptadas tarjetas de créditos de terceros o no emitidas por entidades bancarias. </li>
    </ul>`,
  },
  {
    title:
      "¿Qué documentos debo presentar para recoger el vehículo alquilado? ",
    content: `<ul>
    <li>- Documento de confirmación de reserva impreso.</li>
    <li>- Documento de identidad (DNI) vigente.</li>
    <li>- Licencia de conducir válida.</li>
    <li>- Tarjeta de crédito a nombre del titular de la reserva con limite disponible para el bloqueo de depósito. </li>
    <li>- Pasaporte (si usted es extranjero)</li>
    </ul>`,
  },
  {
    title: "¿De qué trata el contrato de arrendamiento? ",
    content: `<ul>
    <li>El contrato de arrendamiento es un documento con validez legal, firmado entre el titular de la reserva y nuestra compañía. En él figuran descritas todas las condiciones y políticas de contratación del servicio para alquilar el vehículo.</li>
    <li>Deberá leer con especial atención la información y cada cláusula en el dispuestas. Una vez firmado el mismo, implica total acuerdo de sus condiciones y no se admitirá reclamo alguno.</li>
    </ul>`,
  },
  {
    title: "¿El vehículo que alquilo incluye seguro?",
    content: "Sí, todos nuestros vehículos se entregan con seguro vigente.",
  },
  {
    title: "¿Qué elementos no están cubiertos por el seguro? ",
    content: `<ul>
    <li>- Accesorios, neumáticos, llantas y suspensión dañada por agujeros o veredas.</li>
    <li>- Arañazos o abolladuras, grietas en el parabrisas, daños causados por inundaciones u otro fenómeno natural.</li>
    <li>- Pérdida o daño de las llaves o documentación del vehículo.</li>
    </ul>`,
  },
  {
    title: "¿Cómo funciona la política de uso de combustible? ",
    content: `<ul>
    <li>- El vehículo es entregado al cliente con el depósito de combustible lleno y por lo tanto deberá ser devuelto de igual manera.</li>
    <li>- En caso de no ser devuelto según los criterios establecidos en el contrato, la compañía descontará de su garantía de depósito el costo correspondiente según tarifas vigentes del proveedor de nuestra preferencia.</li>
    <li>- Para aquellos clientes que opten por recoger el vehículo con el servicio de entrega en el aeropuerto, el vehículo podrá presentar un nivel de combustible inferior, debido al desplazamiento hasta el punto de entrega.</li>
    <li><span>Importante:</span> En este caso, el reabastecimiento del vehículo el día de la devolución deberá responder a los criterios estipulados por nuestra companía. </li>
    </ul>`,
  },
  {
    title: "¿Qué hacer si mi vuelo se atrasa o adelanta?",
    content: `<ul>
    <li>Al realizar la reserva y optar por la entrega en el aeropuerto, usted deberá informar a nuestra compañía su número de vuelo. Si el mismo sufriera alguna modificación, deberá ponerse en contacto con nosotros e informar a fin de evitar imprevistos. <li>
    <li>Nuestra compañía podrá aplicar costo adicional por tiempo de espera. <li>
    </ul>`,
  },
  {
    title: "¿Puedo salir del país con el vehículo alquilado?",
    content: `<ul>
    <li>No. Queda terminantemente prohibido salir del territorio nacional Argentino. </li>
    <li>En caso de trasladarse a otra provincia deberá informarlo previamente a la compañía. Recuerde que el vehículo deberá ser devuelto dentro del recinto de la Ciudad autónoma de Buenos Aires. 
    </li>
    </ul>`,
  },
  {
    title:
      "¿Qué ocurre si me retraso o me adelanto al momento de la devolución del vehículo? ",
    content: `<ul>
    <li>Si la devolución del vehículo no ocurriera en el horario establecido, serán contabilizadas las horas de exceso de uso y se descontará del depósito de alquiler. 
    Recuerde que si usted no cumple con la fecha de devolución se aplicará una multa económica por infligir acuerdo de devolución. 
    </li>
    <li>La devolución del vehículo antes de la hora prevista y estipulada, no implica un nuevo cálculo de tarifa diaria. </li>
    </ul>`,
  },
  {
    title: "¿Cuáles son las opciones de pago? ",
    content: `<ul>
    <li>Usted podrá abonar el valor del servicio por alquiler en:</li>
    <li>- Pesos argentinos.</li>
    <li>- Dólar estadounidenses (cotización Dolar blue valor venta al momento de la reserva).</li>
    <li>- Transferencia bancaria.</li>
    <li>- -Tarjeta crédito y débito + interés.</li>
    <li>Recuerde que deberá contar con tarjeta de crédito sin excepción para el bloqueo del depósito.</li>
    </ul>`,
  },
  {
    title: "¿Cómo funciona el bloqueo de depósito?",
    content: `<ul>
    <li>Al firmar el contrato de alquiler, el titular de la reserva deberá presentar una tarjeta de crédito a su nombre y con límite disponible para bloquear una cantidad específica determinada por nuestra compañía en función de la categoría del vehículo y periodo de arrendamiento.</li>
    <li>Esta cantidad no será cobrada si usted devuelve el vehículo en iguales condiciones en que lo recibió. Se trata de una garantía qué al momento de devolución de vehículo, si corresponde según requisitos, nuestra compañía solicitara el desbloqueo de la cantidad. El plazo de efectuación del desbloqueo dependerá de la entidad emisora de la tarjeta de crédito.</li>
    </ul>`,
  },
  {
    title: "Extras",
    content: `<ul>
    <li><h4>¿Solo puede conducir el vehículo el titular de la reservación? </h4></li>
    <li>No, podrá incluir hasta 2 conductores adicionales. Cada persona incluida como conductor adicional estará sujeta a los mismos derechos y obligaciones establecidos para el conductor. Debiendo registrar su firma al momento de la reserva.</li>
    <li>Este servicio tendrá un costo adicional y su valor será estipulado al momento de la reserva, dependiendo del vehículo alquilado. </li>
    <li><h4>¿Puedo solicitar una silla para bebé? </h4></li>
    <li>Si. Usted podrá consultar disponibilidad y precios al momento de la reserva.</li>
    <li><h4>¿Puedo retirar el vehículo en el aeropuerto?</h4></li>
    <li>Si. Usted podrá retirar el vehículo en los siguientes aeropuertos:</li>
    <li><span>Aeropuerto Internacional Ezeiza:</span> AU Tte. Gral. Pablo Riccheri Km 33,5, B1802 Ezeiza, Provincia de Buenos Aires.</li>
    <li><span>Aeroparque Internacional Jorge Newbery:</span> Av. Costanera Rafael Obligado s/n, C1425 CABA.</li>
    <li>Debe tener en cuenta que dicho servicio, cuenta con un costo adicional que será incluido en el precio de contratación.</li>
    <li></li>
    <li></li>
    </ul>`,
  },
  {
    title: "Confirmación de reserva",
    content: `<ul>
    <li><h4>¿Cómo se si mi reservación está confirmada?</h4></li>
    <li>Recibirás un e-mail de confirmación con todos los detalles de tu servicio contratado.</li>
    <li><h4>Hice una reserva, pero no recibí e-mail de confirmación. ¿Qué debo hacer?</h4></li>
    <li>El e-mail de confirmación es enviado a la dirección de E-mail que aportas al momento de realizar la solicitud de reservación. Por favor, revisa en tu bandeja de entrada y SPAM (correo no deseado) En caso de no haber recibido e-mail, por favor comunicate con nuestros asesores vía Whatsapp para informarnos. <span>¡Estamos para ayudarte!</span></li>
    <li><h4>¿Puedo cancelar una reserva?</h4></li>
    <li>Si. Usted podrá contactarse con alguno de nuestros asesores para cancelar la reserva realizada. 
    Recuerde que nuestra compañía aplicará gastos administrativos sujetos a la fecha de cancelación con la que usted realice la reserva. 
    </li>
    <li>En caso de que usted quiera reprogramar la fecha de alquiler, su valor dependerá de la disponibilidad, demanda y modificación previa a su reserva original con la que inicie el proceso.</li>
    </ul>`,
  },
];
